<!--
 * @Author: your name
 * @Date: 2020-02-26 21:55:59
 * @LastEditTime: 2020-04-10 10:40:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Result1.vue
 -->
<template>
  <div class="result1">
    <div class="header">
        <img src="../assets/head4.png">
        <div class="title">
          <p class="title_1">焦虑自测量表评测结果</p>
        </div>
    </div>

    <div class="body">
        <div class="part_1">
            <p>根据中国常模测试结果</p>
            <p>你的测试结果为<span class="fen">{{ score }}</span>分</p>
             <p class="description">结果说明</p>
            <p class="description">按本量表按最新中国常模结果设计，总粗分的正常上限为40分，标准分为50分，你焦虑评定的分界值是50分，标准分低于50分值说明你心理状况正常，超过50分说明你有焦虑症状，分值越高，说明您的焦虑症状越严重，需要接受心理咨询甚至需要在医生指导，0-59分为轻度焦虑，60-69分为中度焦虑，69分以上为重度焦虑</p>
            <p class="description2">轻度焦虑: 50—59分</p>
            <p class="description2">中度焦虑: 60—69分</p>
            <p class="description2">重度焦虑: 70分以上</p>
        </div>
        <div class="part_2">
            <p class="colorBlue">本测试仅供参考</p>
            <p class="colorBlue">你是否需要专业咨询为您服务</p>
            <p class="yes" @click="goApply()">是</p>
            <p class="no" @click="goIndex()">否</p>
        </div>
    </div>
     <div class="footer3"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
    <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
// import validator from '@/utils/validator.js'
import Cookies from 'js-cookie'
// import AreaList from '@/utils/area'
// import { pca, pcaa } from 'area-data'
import axios from 'axios'


export default {
  name: 'Result1',
  data() {
    return {
        score: 0
    };
  },

  methods: {
    // 返回上一页
    goback(){
      this.$router.push({ name: "QuestionList"})
    },
    // 去申请页
    goApply(){
       this.$router.push({ name: "Apply"})
    },
    // 去首页
    goIndex(){
      this.$router.push({ name: "Index"})
    }
  },
  mounted: function() {
    this.score = this.$route.query.score
  }

};
</script>

<style lang="less">
.result1 {
  font-size: 16px;
  .header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .title {
      .title_1 {
        position: absolute;
        width: 40%;
        top: 20px;
        font-size: 20px;
        left: 30px;
        color: #34afe8;
      }
    }
  }
  .body {
    margin-top: 12px;
    margin-left: 32px;
    margin-right: 32px;
    .part_1 {
        .fen {
            font-size: 24px;
            color: #34afe8;
        }
        .description{
           font-size: 12px;
          color: #888888;
           margin-block-start: 0;
          margin-block-end: 0;
        }
        .description2{
          margin-block-start: 0;
          margin-block-end: 0;
          font-size: 12px;
          color: #34afe8;
        }
        
    }
    .part_2 {
            width: 80%;
    margin: 20px auto;
    text-align: center;
        text-align: center;
        box-shadow: 0 5px 10px #888888;
        padding-bottom: 12px;
        padding-top: 12px;
        .colorBlue {
            color: #34afe8;
        }
        .yes {
            color: #fff;
            width: 48px;
            margin-left: 42%;
            background-color: #1199d8;
            border: 2px solid;
            border-radius: 25px;
        }
        .no {
            color: #fff;
            width: 48px;
            margin-left: 42%;
            background-color: #828d92;
            border: 2px solid;
            border-radius: 25px;
        }
    }
  }
   .footer3 {
      position: fixed;
      bottom: 0px;
      right: 0;
      img {
        width: 80px;
        background: #34afe8;
        border: 1px dotted #34afe8;
        -webkit-border-radius: 50%;
        border-radius: 10%;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Result1.vue